"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AsbestattestHoeWerktHet() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="bg-background py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-12 lg:gap-16 items-center">
          {}
          <div className={`overflow-hidden rounded-lg shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <div className="relative overflow-hidden group">
              <img src="https://ekonorm.be/wp-content/uploads/2026/01/electrical_inspection_visit_step.webp" alt="Asbestattest inspectieproces" className="w-full h-auto object-cover transition-transform duration-500 ease-out group-hover:scale-[1.02]" />
            </div>
          </div>

          {}
          <div className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
              Asbestattest – Hoe werkt het?
            </h2>
            <p className="text-base text-foreground/80 leading-relaxed mb-6">
              Het aanvragen van een asbestattest bij Ekonorm is eenvoudig en snel. 
              Ons gecertificeerd team zorgt voor een grondige inspectie en levert een 
              officieel attest dat voldoet aan alle wettelijke eisen.
            </p>

            {}
            <ol className="space-y-4 mb-8">
              <li className={`flex items-start gap-3 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] delay-150 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} data-index={0}>
                <span className="flex items-center justify-center size-8 rounded-full bg-primary text-foreground-primary font-semibold text-sm shrink-0">
                  1
                </span>
                <div>
                  <h3 className="font-semibold text-foreground mb-1">
                    Aanvraag indienen
                  </h3>
                  <p className="text-sm text-foreground/70">
                    Vul het aanvraagformulier in met de benodigde gegevens van uw pand.
                  </p>
                </div>
              </li>
              <li className={`flex items-start gap-3 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} data-index={1}>
                <span className="flex items-center justify-center size-8 rounded-full bg-primary text-foreground-primary font-semibold text-sm shrink-0">
                  2
                </span>
                <div>
                  <h3 className="font-semibold text-foreground mb-1">
                    Inspectie plannen
                  </h3>
                  <p className="text-sm text-foreground/70">
                    Wij nemen contact op om een geschikt moment af te spreken voor de inspectie.
                  </p>
                </div>
              </li>
              <li className={`flex items-start gap-3 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] delay-250 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} data-index={2}>
                <span className="flex items-center justify-center size-8 rounded-full bg-primary text-foreground-primary font-semibold text-sm shrink-0">
                  3
                </span>
                <div>
                  <h3 className="font-semibold text-foreground mb-1">
                    Ontvang uw attest
                  </h3>
                  <p className="text-sm text-foreground/70">
                    Na de inspectie ontvangt u binnen enkele werkdagen uw officiële asbestattest.
                  </p>
                </div>
              </li>
            </ol>

            {}
            <Link to="/AsbestosCertificatePage">
              <Button variant="outline" size="lg" className="hover:scale-[1.04] transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)]">
                Meer weten
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}